export const VATTENFALL_SUPPLIER_NAME = 'Vattenfall';
export const TARGET_URL_LOCAL_STORAGE_KEY = 'redirectAfterLogin';
export const IFRAME_TARGET_URL_LOCAL_STORAGE_KEY = 'redirectAfterIframeLogin';
export const METADATA_GRID_DOCUMENT_IDS_LOCAL_STORAGE_KEY = 'documentIds';
export const NAVIGATION_HISTORY_SESSION_STORAGE_KEY = 'navigationHistory';
